import React from "react";

import {
  AlertModal,
  AlertModalBody,
  AlertModalButton,
  AlertModalFooter,
  AlertModalHeading,
} from "@braze/beacon-commons";
import { useLevelsContext } from "@braze/beacon-core";

import { StackOrder } from "@lib/canvasStackOrder";

import type { ConfirmationModalWithIntentProps } from "../types";

export const ConfirmationModalWithIntent = ({
  cancelText,
  okText,
  body,
  heading,
  intent,
  isOpen,
  onCancel,
  onOk,
  onTertiary,
  size,
  tertiaryText,
}: ConfirmationModalWithIntentProps): React.ReactElement => {
  const modalZIndex = useLevelsContext(950, StackOrder.OVERLAY_CONTENT_ABOVE_POPOVER);

  return (
    <AlertModal
      className="confirmation-modal"
      isOpen={isOpen}
      toggle={onCancel}
      intent={intent}
      size={size}
      ignoreOutsideClick
      hideCloseButton
      zIndex={modalZIndex}
    >
      {heading && <AlertModalHeading>{heading}</AlertModalHeading>}
      <AlertModalBody className="confirmation-modal_body">{body}</AlertModalBody>
      <AlertModalFooter className="confirmation-modal_footer">
        {onTertiary && (
          <AlertModalFooter aligner side="left">
            <AlertModalButton
              className="confirmation-modal_tertiary-button"
              variant="tertiary"
              onClick={onTertiary}
            >
              {tertiaryText}
            </AlertModalButton>
          </AlertModalFooter>
        )}
        <AlertModalFooter aligner side="right">
          <AlertModalButton
            className="confirmation-modal_cancel-button bcl-ignore-click-outside"
            variant="secondary"
            onClick={onCancel}
          >
            {cancelText}
          </AlertModalButton>
          <AlertModalButton
            className="confirmation-modal_ok-button bcl-ignore-click-outside"
            variant="primary"
            onClick={onOk}
          >
            {okText}
          </AlertModalButton>
        </AlertModalFooter>
      </AlertModalFooter>
    </AlertModal>
  );
};
